import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE = process.env.REACT_APP_API;

export const api = axios.create({
  baseURL: API_BASE,
});

// OPTIONAL: You can still keep setAuthToken for manual JWT use,
// but Firebase token interceptor will override it on each request.
export const setAuthToken = (token) => {
  api.defaults.headers.common["Authorization"] = token ? `Bearer ${token}` : "";
};

// 🔥 New: Automatically attach Firebase Auth Token to every request
api.interceptors.request.use(async (config) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    const token = await user.getIdToken(); // Firebase ID token
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});
